<template>
  <div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
// import BottomNavigation from "@/components/BottomNavigation.vue";

export default {
};
</script>

<style></style>